import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import OrderExportForm from './OrderExportForm';

function OrderExportModal(props) {
  const {
    shown, t, orderExport, onClose, sale,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [orderExport, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="lg"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Distribution Order')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <OrderExportForm entity={orderExport} sale={sale} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="OrderExportForm"
          className="btn btn-primary"
        >
          {t('Place Order')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

OrderExportModal.defaultProps = {
  shown: false,
  onSuccess: () => { },
  orderExport: {},
  sale: {},
  onClose: () => {},
};

OrderExportModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  orderExport: PropTypes.object,
  sale: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(OrderExportModal));
